// extracted by mini-css-extract-plugin
module.exports = {"tile":"IconTile_tile__TC0xZ"};